namespace GeniuzPOS.Purchase {
    export class PoPurRequestColumns {
        static columnsKey = 'Purchase.PoPurRequest';
    }
}
